import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import storage from '~/utils/storage';

/**
 * Setup axios interceptors for global request/response handling
 */
const setupInterceptors = () => {
  // Request interceptor
  axios.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      // No need to manually add Authorization header anymore
      // HttpOnly cookies will be automatically sent with requests
      return config;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor
  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      // Handle successful responses
      return response;
    },
    async (error: AxiosError) => {
      // Handle error responses
      if (error.response) {
        // Handle specific status codes
        switch (error.response.status) {
          case 401:
            // Unauthorized - clear user data and redirect to login
            await storage.remove('user');
            // You might want to trigger a redirect or dispatch an action here
            break;
          case 403:
            // Forbidden
            console.error('Access forbidden');
            break;
          case 404:
            // Not found
            console.error('Resource not found');
            break;
          case 500:
            // Server error
            console.error('Server error');
            break;
          default:
            // Other errors
            console.error('Request failed');
        }
      } else if (error.request) {
        // The request was made but no response was received
        console.error('No response received from server');
      } else {
        // Something happened in setting up the request
        console.error('Error setting up request:', error.message);
      }

      return Promise.reject(error);
    }
  );
};

export default setupInterceptors;
